import React from 'react';
import { FlapperSpinner } from 'react-spinners-kit';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    minHeight: '300px',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

interface Props {
  color?: React.CSSProperties['color'];
}

const Loading: React.FC<Props> = ({ color }) => {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <Container className={classes.root}>
      <FlapperSpinner color={color ?? theme.palette.primary.main} size={50} />
    </Container>
  );
};

export default Loading;
